import { GridType } from "../../../../Entities/GridType";
import ProjectCapacity from "./ProjectCapacity";

export const AllocationView = () => <ProjectCapacity gridType={GridType.Allocation} />